import createIcon from '../../createIcon';

/**
 * @component @name PersonSearch
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTAgMTFDMTIuMjA5MSAxMSAxNCA5LjIwOTE0IDE0IDdDMTQgNC43OTA4NiAxMi4yMDkxIDMgMTAgM0M3Ljc5MDg2IDMgNiA0Ljc5MDg2IDYgN0M2IDkuMjA5MTQgNy43OTA4NiAxMSAxMCAxMVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xMC4zNSAxMy4wMUM3LjYyIDEyLjkxIDIgMTQuMjcgMiAxN1YxOUgxMS41NEM5LjA3IDE2LjI0IDEwLjMxIDEzLjExIDEwLjM1IDEzLjAxWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE5LjQzIDE3LjAyQzE5Ljc5IDE2LjQzIDIwIDE1Ljc0IDIwIDE1QzIwIDEyLjc5IDE4LjIxIDExIDE2IDExQzEzLjc5IDExIDEyIDEyLjc5IDEyIDE1QzEyIDE3LjIxIDEzLjc5IDE5IDE2IDE5QzE2Ljc0IDE5IDE3LjQzIDE4Ljc4IDE4LjAyIDE4LjQzTDIwLjU5IDIxTDIyIDE5LjU5TDE5LjQzIDE3LjAyWk0xNiAxN0MxNC45IDE3IDE0IDE2LjEgMTQgMTVDMTQgMTMuOSAxNC45IDEzIDE2IDEzQzE3LjEgMTMgMTggMTMuOSAxOCAxNUMxOCAxNi4xIDE3LjEgMTcgMTYgMTdaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PersonSearch = createIcon('PersonSearch', [
  [
    'path',
    {
      d: 'M10 11C12.2091 11 14 9.20914 14 7C14 4.79086 12.2091 3 10 3C7.79086 3 6 4.79086 6 7C6 9.20914 7.79086 11 10 11Z',
      key: 'n7ifde',
    },
  ],
  [
    'path',
    {
      d: 'M10.35 13.01C7.62 12.91 2 14.27 2 17V19H11.54C9.07 16.24 10.31 13.11 10.35 13.01Z',
      key: '1xnu5z',
    },
  ],
  [
    'path',
    {
      d: 'M19.43 17.02C19.79 16.43 20 15.74 20 15C20 12.79 18.21 11 16 11C13.79 11 12 12.79 12 15C12 17.21 13.79 19 16 19C16.74 19 17.43 18.78 18.02 18.43L20.59 21L22 19.59L19.43 17.02ZM16 17C14.9 17 14 16.1 14 15C14 13.9 14.9 13 16 13C17.1 13 18 13.9 18 15C18 16.1 17.1 17 16 17Z',
      key: '1u57zq',
    },
  ],
]);

export default PersonSearch;
